<script setup lang="ts">
import $ from 'jquery';
import type { BaseTransitionProps } from 'vue';

const props = defineProps<{
    duration?: number;
}>();
const emit = defineEmits<{
    (event: 'before-enter'): void;
    (event: 'before-leave'): void;
    (event: 'before-transition', value: boolean): void;
    (event: 'after-enter'): void;
    (event: 'after-leave'): void;
    (event: 'after-transition', value: boolean): void;
}>();

const enter: BaseTransitionProps['onEnter'] = (el, done) => {
    $(el).hide();
    emit('before-enter');
    emit('before-transition', true);
    $(el).slideDown(props.duration ?? 400, () => {
        done();
        emit('after-enter');
        emit('after-transition', true);
    });
};

const leave: BaseTransitionProps['onLeave'] = (el, done) => {
    $(el).show();
    emit('before-leave');
    emit('before-transition', false);
    $(el).slideUp(props.duration ?? 400, () => {
        done();
        emit('after-leave');
        emit('after-transition', false);
    });
};
</script>

<template>
    <Transition
        :css="false"
        @enter="enter"
        @leave="leave"
    >
        <slot />
    </Transition>
</template>
